import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromMapSettings from '../reducers/map-settings.reducer';

export const selectMapSettingsState =
  createFeatureSelector<fromMapSettings.State>(
    fromMapSettings.mapSettingsFeatureKey,
  );

export const getSelectedLayer = createSelector(
  selectMapSettingsState,
  fromMapSettings.getSelectedLayer,
);

export const getBaseMap = createSelector(
  selectMapSettingsState,
  fromMapSettings.getBaseMap,
);

export const getTrafficLayer = createSelector(
  selectMapSettingsState,
  fromMapSettings.getTrafficLayer,
);

export const getLocationLayer = createSelector(
  selectMapSettingsState,
  fromMapSettings.getLocationLayer,
);

export const getMapSettings = createSelector(
  selectMapSettingsState,
  (state) => state,
);

export const getMapLoaded = createSelector(
  selectMapSettingsState,
  fromMapSettings.getMapLoaded,
);
